module.exports = __webpack_public_path__ + "img/late_cancel_status.900cd15d.svg";